import { render, staticRenderFns } from "./shipping-timer.vue?vue&type=template&id=b3c75a6a&scoped=true&"
import script from "./shipping-timer.vue?vue&type=script&lang=js&"
export * from "./shipping-timer.vue?vue&type=script&lang=js&"
import style0 from "./shipping-timer.vue?vue&type=style&index=0&id=b3c75a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c75a6a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Translated: require('/opt/build/repo/storefront/components/legacy/global/translated.vue').default})
